import React, { useEffect, useState } from 'react';
import classes from "./SuccessPage.module.css";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineLoading3Quarters } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { checkDeactivateCallbackApi, checkSubscriptionApi } from '../Http/http';

const DeactivateProcessing = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // const checkSubscription = async () => {
    //     try {
    //         // setLoading(true);
    //         checkSubscriptionApi({ msisdn: Cookies.get("msisdn") }).then().catch(err => {
    //             Cookies.remove('msisdn');
    //             window.location.href = "https://subscribe-d2g.rashigames.com/"
    //         });

    //         // setLoading(false);
    //     } catch (error) {
    //         // setLoading(false);
    //         alert("Something Went Wrong!");
    //     }
    // }

      const checkCallback = async () => {
            try {
                setLoading(true);
                const response = await checkDeactivateCallbackApi({msisdn:Cookies.get("msisdn")});
                console.log(response, 'response...');
                setLoading(false);
                Cookies.remove("msisdn");
                navigate("/deactivation-success");
            } catch (error) {
                setLoading(false);
                console.log(error, 'error--');
            }
        }

    // useEffect(() => {
    //     if (Cookies.get("msisdn")) {
    //         checkSubscription();
    //     }
    //     else {
    //         window.location.href = "https://subscribe-d2g.rashigames.com/"
    //     }
    // }, []);

    useEffect(() => {
        if (!loading && Cookies.get("msisdn")) {
            const apiInterval = setInterval(() => {
                checkCallback();
            }, 2000);
            return () => {
                clearInterval(apiInterval);
            }
        }
    }, [loading]);

    return (
        <div className={classes.wrapper}>
            <div className={classes.statusContainer}>
                <AiOutlineLoading3Quarters className={classes.iconLoading} />
                <h2>Deactivating...</h2>
                <p>Please wait while we process your deactivation.</p>
            </div>
        </div>
    )
}

export default DeactivateProcessing